export enum UserAvailableColumns {
    NsContactName = 'nsContactName',
    Email = 'email',
    Role = 'role',
    FirstName = 'firstName',
    MiddleName = 'middleName',
    LastName = 'lastName',
    Status = 'status',
    Products = 'products',
    Actions = 'actions',
}
